import React from "react";
import { Modal as MuiModal } from "@mui/material";

import { ModalContainer } from "./styles.js";

type ModalProps = {
  id?: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showClose?: boolean;
  showIcon?: boolean;
  icon?: string | React.ReactNode;
  title?: string;
  subTitle?: string;
  isWide?: boolean;
  slim?: boolean;
};

const Modal = ({
  id,
  open,
  onClose,
  children,
  showClose = true,
  icon,
  title,
  subTitle,
  showIcon = false,
  isWide = false,
  slim = false,
}: ModalProps) => {
  return (
    <MuiModal open={open} onClose={onClose} disableScrollLock={true}>
      <ModalContainer
        id={id}
        className={`${isWide ? "wider" : ""} ${slim ? "slim" : ""}`}
      >
        {title && (
          <div className="modal-header">
            {showIcon && icon && (
              <div className="modal-icon">
                {typeof icon === "string" ? (
                  <img src={icon} alt="" />
                ) : (
                  <>{icon}</>
                )}
              </div>
            )}
            <h2>
              {title} {subTitle && <span>{subTitle}</span>}
            </h2>
          </div>
        )}
        <div className="modal-inner">{children}</div>
        {showClose && (
          <button className="close-icon" onClick={onClose}>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6.5L6 18.5M6 6.5L18 18.5"
                stroke="#A4A7AE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </ModalContainer>
    </MuiModal>
  );
};

export default Modal;
